import _ from 'lodash'
import { connect } from 'react-redux'
import LoginWindow from '../../components/LoginWindow'
import localizeImport from '../../store/localize'
import getAttributes from '../../store/attributes'
import strings from '../../components/LoginWindow/login-window.json'
import { actionUpdateAutoLaunchOnStartup } from '../../actions'
import { selectors as settingsSelectors } from '../../features/Settings'
import { selectors as backendSelectors } from '../../features/Backend'
import { actions as toasterActions } from '../../features/Toaster'
import { selectors as steamSelectors, actions as steamActions } from '../../features/Steam'
import { selectors as usersSelectors, actions as usersActions } from '../../features/Users'
import {
    logoutFromSSO as logoutFromSSOImport,
    updateIframeStyles,
    addRememberAccountCheckbox as addRememberAccountCheckboxImport,
    correctOpenLinks,
    checkIfEULA,
} from '../../components/LoginWindow/sso-commands'
import { ltsLogin as ltsLoginImport } from '../../launcherBackend/lts-service'

const getSsoUrl = (server, locale, sso, steam) => {
    if (
        server == null ||
        _.isEmpty(server) ||
        locale == null ||
        server.sso == null ||
        server.sso.url == null
    ) {
        return ''
    }

    // Get the login url for the SSO
    let loginUrl = sso.login

    // Check if we should add the steam parameter to the url
    if (steam.steamStartup && !steam.hasLoggedIn) {
        // Add steam path to url
        loginUrl += sso.steam
    }

    // Return the login url with the correct parameters
    return loginUrl
        .replace(/{host}/gi, server.sso.url)
        .replace('{locale}', locale)
        .replace('{steamTicket}', steam.ticket)
}

function mapStateToProps(state) {
    const steam = steamSelectors.getSteamInfo(state)
    const locale = backendSelectors.getLocale(state)
    const server = backendSelectors.getActiveServer(state)
    const showCancel = usersSelectors.getActiveLoggedInUserIds(state).length > 0
    const attributes = getAttributes(locale)
    const sso = attributes.service.sso
    const thirdPartyLogin = attributes.service.thirdPartyLogin
    const ssoUrl = getSsoUrl(server, locale, sso, steam)

    const logoutFromSSO = (iframe, iframeUrl) =>
        logoutFromSSOImport(server.sso.url, iframeUrl, ssoUrl, sso.logout, iframe)

    const localize = value => localizeImport(strings, locale, value)

    const ltsLogin = (code, rememberAccount) =>
        ltsLoginImport(
            server,
            code,
            rememberAccount,
            settingsSelectors.getAutoLaunchOnLogin(state),
            locale,
        )

    const addRememberAccountCheckbox = (iframe, iframeUrl, remember) =>
        addRememberAccountCheckboxImport(
            iframe,
            iframeUrl,
            remember,
            localize('rememberAccount'),
            localize('insecure'),
        )

    return {
        server,
        locale,
        steam,
        showCancel,
        thirdPartyLogin,
        logoutFromSSO,
        ssoUrl,
        updateIframeStyles,
        addRememberAccountCheckbox,
        correctOpenLinks,
        checkIfEULA,
        cancelText: localize('cancel'),
        ltsLogin,
        // Note that this is incorrectly named as an action!
        updateLaunchOnStartup: actionUpdateAutoLaunchOnStartup,
    }
}

const loginUser = user => (dispatch, getState) => {
    const serverId = backendSelectors.getActiveServerId(getState())
    dispatch(usersActions.logIn(serverId, user))
    window.setToken()
}

const updateSteam = () => (dispatch, getState) => {
    // Clone the Steam object
    const steam = { ...steamSelectors.getSteamInfo(getState()) }
    // Update has logged in state
    steam.hasLoggedIn = true
    // Update the used ticket
    steam.usedTicket = steam.ticket
    // Update the steam status
    dispatch(steamActions.updateSteam(steam))
}

const displayError = () => (dispatch, getState) => {
    const locale = backendSelectors.getLocale(getState())
    const localize = value => localizeImport(strings, locale, value)
    const title = localize('error')
    const message = localize('error_loginUser')
    dispatch(toasterActions.addError({ title, content: message }))
}

function mapDispatchToProps(dispatch) {
    return {
        loginUser: (user) => {
            dispatch(loginUser(user))
        },
        updateSteam: () => {
            dispatch(updateSteam())
        },
        displayError: () => {
            dispatch(displayError())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginWindow)



// WEBPACK FOOTER //
// ./src/containers/LoginWindow/login-window.js